import React from 'react';
import { Link } from 'react-router-dom';
import { FaNetworkWired, FaTools, FaDesktop, FaArrowLeft } from 'react-icons/fa';
import styles from './ITServiceCards.module.css';

const privateServices = [
  {
    title: 'התקנה ותיקון מחשבים',
    description: 'שירותי התקנה, תיקון ותחזוקת מחשבים ביתיים. אני מתמחה בפתרון בעיות חומרה ותוכנה.',
    icon: <FaTools />
  },
  {
    title: 'שדרוגי חומרה',
    description: 'שדרוג רכיבי חומרה כמו זיכרון, דיסקים וכרטיסי מסך לשיפור ביצועי המחשב.',
    icon: <FaDesktop />
  },
  {
    title: 'פתרונות רשת ביתית',
    description: 'התקנה והגדרה של רשתות ביתיות, מכשירי נתב אלחוטיים ופתרונות קישוריות.',
    icon: <FaNetworkWired />
  },
];

const ITServiceCards = () => {
  return (
    <div className={styles.itServicesGrid}>
      {privateServices.map((benefit, index) => (
        <div className={styles.itServiceCard} key={`benefit-${index}`}> 
          <div className={styles.itServiceIcon}>{benefit.icon}</div>
          <h3 className={styles.itServiceTitle}>{benefit.title}</h3>
          <p className={styles.itServiceDescription}>{benefit.description}</p>
        </div>
      ))}
      <Link to="/information-technology/works-with" className={styles.itServiceCardLink}>
        <div className={styles.itServiceIcon}><FaArrowLeft /></div>
        <h3 className={styles.itServiceTitle}>לכל השירותים</h3>
        <p className={styles.itServiceDescription}>צפו בכל השירותים שאני מציע</p>
      </Link>
    </div>
  );
};

export default ITServiceCards; 